/* 🤖 this file was generated by svg-to-ts */
export const matIconTextFields: {
  name: 'text-fields';
  data: string;
} = {
  name: 'text-fields',
  data: `<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24"><path d="M2.5 4v3h5v12h3V7h5V4h-13zm19 5h-9v3h3v7h3v-7h3V9z"/></svg>`
};
